/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * App 内嵌终端：home_app（由同名 WAP 终端全量派生，B 位 *_wap 重写为 home_app，C/D 不变；404 个 D 位坑位，19 个 C 位模块）。
 * 数据源：home_wap（全量派生）。
 * 曝光事件上报模块编码（module.code，A.B.C）；点击事件上报坑位完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const HOME_APP_SPM_CODES = {
  best_sellers: {
    code: `${sitePrefix}.home_app.best_sellers`,
    product_001: `${sitePrefix}.home_app.best_sellers.product_001`,
    product_002: `${sitePrefix}.home_app.best_sellers.product_002`,
    product_003: `${sitePrefix}.home_app.best_sellers.product_003`,
    product_004: `${sitePrefix}.home_app.best_sellers.product_004`,
    product_005: `${sitePrefix}.home_app.best_sellers.product_005`,
    product_006: `${sitePrefix}.home_app.best_sellers.product_006`,
    product_007: `${sitePrefix}.home_app.best_sellers.product_007`,
    product_008: `${sitePrefix}.home_app.best_sellers.product_008`,
    tab_option_01: `${sitePrefix}.home_app.best_sellers.tab_option_01`,
    tab_option_02: `${sitePrefix}.home_app.best_sellers.tab_option_02`,
    view_more: `${sitePrefix}.home_app.best_sellers.view_more`,
  },
  eyewear_inspiration: {
    code: `${sitePrefix}.home_app.eyewear_inspiration`,
    open_eyewear_inspiration1: `${sitePrefix}.home_app.eyewear_inspiration.open_eyewear_inspiration1`,
    open_eyewear_inspiration2: `${sitePrefix}.home_app.eyewear_inspiration.open_eyewear_inspiration2`,
  },
  footer_app: {
    code: `${sitePrefix}.home_app.footer_app`,
    download_android_app: `${sitePrefix}.home_app.footer_app.download_android_app`,
    open_download_on_the_app_store: `${sitePrefix}.home_app.footer_app.open_download_on_the_app_store`,
  },
  footer_help: {
    code: `${sitePrefix}.home_app.footer_help`,
    open_help_center: `${sitePrefix}.home_app.footer_help.open_help_center`,
    open_order_tracking: `${sitePrefix}.home_app.footer_help.open_order_tracking`,
  },
  footer_navigation: {
    code: `${sitePrefix}.home_app.footer_navigation`,
    footer_group_toggle_01: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_01`,
    footer_group_toggle_02: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_02`,
    footer_group_toggle_03: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_03`,
    footer_group_toggle_04: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_04`,
    footer_group_toggle_05: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_05`,
    footer_group_toggle_06: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_06`,
    footer_group_toggle_07: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_07`,
    footer_group_toggle_08: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_08`,
    footer_group_toggle_09: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_09`,
    footer_group_toggle_10: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_10`,
    footer_group_toggle_11: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_11`,
    footer_group_toggle_12: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_12`,
    footer_group_toggle_13: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_13`,
    footer_group_toggle_14: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_14`,
    footer_group_toggle_15: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_15`,
    footer_group_toggle_16: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_16`,
    footer_group_toggle_17: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_17`,
    footer_group_toggle_18: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_18`,
    footer_group_toggle_19: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_19`,
    footer_group_toggle_20: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_20`,
    footer_group_toggle_21: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_21`,
    footer_group_toggle_22: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_22`,
    footer_group_toggle_23: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_23`,
    footer_group_toggle_24: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_24`,
    footer_group_toggle_25: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_25`,
    footer_group_toggle_26: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_26`,
    footer_group_toggle_27: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_27`,
    footer_group_toggle_28: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_28`,
    footer_group_toggle_29: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_29`,
    footer_group_toggle_30: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_30`,
    footer_group_toggle_31: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_31`,
    footer_group_toggle_32: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_32`,
    footer_group_toggle_33: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_33`,
    footer_group_toggle_34: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_34`,
    footer_group_toggle_35: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_35`,
    footer_group_toggle_36: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_36`,
    footer_group_toggle_37: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_37`,
    footer_group_toggle_38: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_38`,
    footer_group_toggle_39: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_39`,
    footer_group_toggle_40: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_40`,
    footer_group_toggle_41: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_41`,
    footer_group_toggle_42: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_42`,
    footer_group_toggle_43: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_43`,
    footer_group_toggle_44: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_44`,
    footer_group_toggle_45: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_45`,
    footer_group_toggle_46: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_46`,
    footer_group_toggle_47: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_47`,
    footer_group_toggle_48: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_48`,
    footer_group_toggle_49: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_49`,
    footer_group_toggle_50: `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_50`,
    footer_link_01: `${sitePrefix}.home_app.footer_navigation.footer_link_01`,
    footer_link_02: `${sitePrefix}.home_app.footer_navigation.footer_link_02`,
    footer_link_03: `${sitePrefix}.home_app.footer_navigation.footer_link_03`,
    footer_link_04: `${sitePrefix}.home_app.footer_navigation.footer_link_04`,
    footer_link_05: `${sitePrefix}.home_app.footer_navigation.footer_link_05`,
    footer_link_06: `${sitePrefix}.home_app.footer_navigation.footer_link_06`,
    footer_link_07: `${sitePrefix}.home_app.footer_navigation.footer_link_07`,
    footer_link_08: `${sitePrefix}.home_app.footer_navigation.footer_link_08`,
    footer_link_09: `${sitePrefix}.home_app.footer_navigation.footer_link_09`,
    footer_link_10: `${sitePrefix}.home_app.footer_navigation.footer_link_10`,
    footer_link_11: `${sitePrefix}.home_app.footer_navigation.footer_link_11`,
    footer_link_12: `${sitePrefix}.home_app.footer_navigation.footer_link_12`,
    footer_link_13: `${sitePrefix}.home_app.footer_navigation.footer_link_13`,
    footer_link_14: `${sitePrefix}.home_app.footer_navigation.footer_link_14`,
    footer_link_15: `${sitePrefix}.home_app.footer_navigation.footer_link_15`,
    footer_link_16: `${sitePrefix}.home_app.footer_navigation.footer_link_16`,
    footer_link_17: `${sitePrefix}.home_app.footer_navigation.footer_link_17`,
    footer_link_18: `${sitePrefix}.home_app.footer_navigation.footer_link_18`,
    footer_link_19: `${sitePrefix}.home_app.footer_navigation.footer_link_19`,
    footer_link_20: `${sitePrefix}.home_app.footer_navigation.footer_link_20`,
    footer_link_21: `${sitePrefix}.home_app.footer_navigation.footer_link_21`,
    footer_link_22: `${sitePrefix}.home_app.footer_navigation.footer_link_22`,
    footer_link_23: `${sitePrefix}.home_app.footer_navigation.footer_link_23`,
    footer_link_24: `${sitePrefix}.home_app.footer_navigation.footer_link_24`,
    footer_link_25: `${sitePrefix}.home_app.footer_navigation.footer_link_25`,
    footer_link_26: `${sitePrefix}.home_app.footer_navigation.footer_link_26`,
    footer_link_27: `${sitePrefix}.home_app.footer_navigation.footer_link_27`,
    footer_link_28: `${sitePrefix}.home_app.footer_navigation.footer_link_28`,
    footer_link_29: `${sitePrefix}.home_app.footer_navigation.footer_link_29`,
    footer_link_30: `${sitePrefix}.home_app.footer_navigation.footer_link_30`,
    footer_link_31: `${sitePrefix}.home_app.footer_navigation.footer_link_31`,
    footer_link_32: `${sitePrefix}.home_app.footer_navigation.footer_link_32`,
    footer_link_33: `${sitePrefix}.home_app.footer_navigation.footer_link_33`,
    footer_link_34: `${sitePrefix}.home_app.footer_navigation.footer_link_34`,
    footer_link_35: `${sitePrefix}.home_app.footer_navigation.footer_link_35`,
    footer_link_36: `${sitePrefix}.home_app.footer_navigation.footer_link_36`,
    footer_link_37: `${sitePrefix}.home_app.footer_navigation.footer_link_37`,
    footer_link_38: `${sitePrefix}.home_app.footer_navigation.footer_link_38`,
    footer_link_39: `${sitePrefix}.home_app.footer_navigation.footer_link_39`,
  },
  footer_social: {
    code: `${sitePrefix}.home_app.footer_social`,
    social_entry_01: `${sitePrefix}.home_app.footer_social.social_entry_01`,
    social_entry_02: `${sitePrefix}.home_app.footer_social.social_entry_02`,
    social_entry_03: `${sitePrefix}.home_app.footer_social.social_entry_03`,
    social_entry_04: `${sitePrefix}.home_app.footer_social.social_entry_04`,
    social_entry_05: `${sitePrefix}.home_app.footer_social.social_entry_05`,
    social_entry_06: `${sitePrefix}.home_app.footer_social.social_entry_06`,
  },
  footer_subscribe: {
    code: `${sitePrefix}.home_app.footer_subscribe`,
    email_input: `${sitePrefix}.home_app.footer_subscribe.email_input`,
    submit_subscription: `${sitePrefix}.home_app.footer_subscribe.submit_subscription`,
  },
  header_tools: {
    code: `${sitePrefix}.home_app.header_tools`,
    cart_entry: `${sitePrefix}.home_app.header_tools.cart_entry`,
    logo_entry: `${sitePrefix}.home_app.header_tools.logo_entry`,
    open_account: `${sitePrefix}.home_app.header_tools.open_account`,
    open_search: `${sitePrefix}.home_app.header_tools.open_search`,
    toggle_navigation: `${sitePrefix}.home_app.header_tools.toggle_navigation`,
  },
  hero_banner: {
    code: `${sitePrefix}.home_app.hero_banner`,
    banner_01: `${sitePrefix}.home_app.hero_banner.banner_01`,
    banner_02: `${sitePrefix}.home_app.hero_banner.banner_02`,
    banner_03: `${sitePrefix}.home_app.hero_banner.banner_03`,
    slide_indicator_01: `${sitePrefix}.home_app.hero_banner.slide_indicator_01`,
    slide_indicator_02: `${sitePrefix}.home_app.hero_banner.slide_indicator_02`,
    slide_indicator_03: `${sitePrefix}.home_app.hero_banner.slide_indicator_03`,
  },
  mobile_navigation: {
    code: `${sitePrefix}.home_app.mobile_navigation`,
    nav_item_01: `${sitePrefix}.home_app.mobile_navigation.nav_item_01`,
    nav_item_02: `${sitePrefix}.home_app.mobile_navigation.nav_item_02`,
    nav_item_03: `${sitePrefix}.home_app.mobile_navigation.nav_item_03`,
    nav_item_04: `${sitePrefix}.home_app.mobile_navigation.nav_item_04`,
    nav_item_05: `${sitePrefix}.home_app.mobile_navigation.nav_item_05`,
    nav_item_06: `${sitePrefix}.home_app.mobile_navigation.nav_item_06`,
    open_contact_us: `${sitePrefix}.home_app.mobile_navigation.open_contact_us`,
    open_help_center: `${sitePrefix}.home_app.mobile_navigation.open_help_center`,
    open_order_tracking: `${sitePrefix}.home_app.mobile_navigation.open_order_tracking`,
    site_settings_entry: `${sitePrefix}.home_app.mobile_navigation.site_settings_entry`,
    social_entry_01: `${sitePrefix}.home_app.mobile_navigation.social_entry_01`,
    social_entry_02: `${sitePrefix}.home_app.mobile_navigation.social_entry_02`,
    social_entry_03: `${sitePrefix}.home_app.mobile_navigation.social_entry_03`,
    social_entry_04: `${sitePrefix}.home_app.mobile_navigation.social_entry_04`,
    social_entry_05: `${sitePrefix}.home_app.mobile_navigation.social_entry_05`,
    social_entry_06: `${sitePrefix}.home_app.mobile_navigation.social_entry_06`,
    submenu_item_01_01: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_01`,
    submenu_item_01_02: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_02`,
    submenu_item_01_03: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_03`,
    submenu_item_01_04: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_04`,
    submenu_item_01_05: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_05`,
    submenu_item_01_06: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_06`,
    submenu_item_01_07: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_07`,
    submenu_item_01_08: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_08`,
    submenu_item_01_09: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_09`,
    submenu_item_01_10: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_10`,
    submenu_item_01_11: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_11`,
    submenu_item_01_12: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_12`,
    submenu_item_01_13: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_13`,
    submenu_item_01_14: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_14`,
    submenu_item_01_15: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_15`,
    submenu_item_01_16: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_16`,
    submenu_item_01_17: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_17`,
    submenu_item_01_18: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_18`,
    submenu_item_01_19: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_19`,
    submenu_item_01_20: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_20`,
    submenu_item_01_21: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_21`,
    submenu_item_01_22: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_22`,
    submenu_item_01_23: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_23`,
    submenu_item_01_24: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_24`,
    submenu_item_01_25: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_25`,
    submenu_item_01_26: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_26`,
    submenu_item_01_27: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_27`,
    submenu_item_01_28: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_28`,
    submenu_item_01_29: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_29`,
    submenu_item_01_30: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_30`,
    submenu_item_01_31: `${sitePrefix}.home_app.mobile_navigation.submenu_item_01_31`,
    submenu_item_02_01: `${sitePrefix}.home_app.mobile_navigation.submenu_item_02_01`,
    submenu_item_02_02: `${sitePrefix}.home_app.mobile_navigation.submenu_item_02_02`,
    submenu_item_02_03: `${sitePrefix}.home_app.mobile_navigation.submenu_item_02_03`,
    submenu_item_02_04: `${sitePrefix}.home_app.mobile_navigation.submenu_item_02_04`,
    submenu_item_02_05: `${sitePrefix}.home_app.mobile_navigation.submenu_item_02_05`,
    submenu_item_02_06: `${sitePrefix}.home_app.mobile_navigation.submenu_item_02_06`,
    submenu_item_03_01: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_01`,
    submenu_item_03_02: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_02`,
    submenu_item_03_03: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_03`,
    submenu_item_03_04: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_04`,
    submenu_item_03_05: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_05`,
    submenu_item_03_06: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_06`,
    submenu_item_03_07: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_07`,
    submenu_item_03_08: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_08`,
    submenu_item_03_09: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_09`,
    submenu_item_03_10: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_10`,
    submenu_item_03_11: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_11`,
    submenu_item_03_12: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_12`,
    submenu_item_03_13: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_13`,
    submenu_item_03_14: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_14`,
    submenu_item_03_15: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_15`,
    submenu_item_03_16: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_16`,
    submenu_item_03_17: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_17`,
    submenu_item_03_18: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_18`,
    submenu_item_03_19: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_19`,
    submenu_item_03_20: `${sitePrefix}.home_app.mobile_navigation.submenu_item_03_20`,
    submenu_item_04_01: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_01`,
    submenu_item_04_02: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_02`,
    submenu_item_04_03: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_03`,
    submenu_item_04_04: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_04`,
    submenu_item_04_05: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_05`,
    submenu_item_04_06: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_06`,
    submenu_item_04_07: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_07`,
    submenu_item_04_08: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_08`,
    submenu_item_04_09: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_09`,
    submenu_item_04_10: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_10`,
    submenu_item_04_11: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_11`,
    submenu_item_04_12: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_12`,
    submenu_item_04_13: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_13`,
    submenu_item_04_14: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_14`,
    submenu_item_04_15: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_15`,
    submenu_item_04_16: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_16`,
    submenu_item_04_17: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_17`,
    submenu_item_04_18: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_18`,
    submenu_item_04_19: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_19`,
    submenu_item_04_20: `${sitePrefix}.home_app.mobile_navigation.submenu_item_04_20`,
  },
  new_customer_offer: {
    code: `${sitePrefix}.home_app.new_customer_offer`,
    banner_01: `${sitePrefix}.home_app.new_customer_offer.banner_01`,
  },
  personalized_recommendations: {
    code: `${sitePrefix}.home_app.personalized_recommendations`,
    action_07: `${sitePrefix}.home_app.personalized_recommendations.action_07`,
    color_swatch_001_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_001_01`,
    color_swatch_001_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_001_02`,
    color_swatch_001_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_001_03`,
    color_swatch_002_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_002_01`,
    color_swatch_002_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_002_02`,
    color_swatch_002_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_002_03`,
    color_swatch_003_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_003_01`,
    color_swatch_003_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_003_02`,
    color_swatch_003_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_003_03`,
    color_swatch_004_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_004_01`,
    color_swatch_004_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_004_02`,
    color_swatch_004_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_004_03`,
    color_swatch_005_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_005_01`,
    color_swatch_005_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_005_02`,
    color_swatch_005_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_005_03`,
    color_swatch_006_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_006_01`,
    color_swatch_006_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_006_02`,
    color_swatch_006_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_006_03`,
    color_swatch_007_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_007_01`,
    color_swatch_007_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_007_02`,
    color_swatch_007_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_007_03`,
    color_swatch_008_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_008_01`,
    color_swatch_008_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_008_02`,
    color_swatch_008_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_008_03`,
    color_swatch_009_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_009_01`,
    color_swatch_009_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_009_02`,
    color_swatch_009_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_009_03`,
    color_swatch_010_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_010_01`,
    color_swatch_010_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_010_02`,
    color_swatch_010_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_010_03`,
    color_swatch_011_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_011_01`,
    color_swatch_011_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_011_02`,
    color_swatch_011_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_011_03`,
    color_swatch_012_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_012_01`,
    color_swatch_012_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_012_02`,
    color_swatch_012_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_012_03`,
    color_swatch_013_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_013_01`,
    color_swatch_013_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_013_02`,
    color_swatch_013_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_013_03`,
    color_swatch_014_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_014_01`,
    color_swatch_014_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_014_02`,
    color_swatch_014_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_014_03`,
    color_swatch_015_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_015_01`,
    color_swatch_015_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_015_02`,
    color_swatch_015_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_015_03`,
    color_swatch_016_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_016_01`,
    color_swatch_016_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_016_02`,
    color_swatch_016_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_016_03`,
    color_swatch_017_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_017_01`,
    color_swatch_017_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_017_02`,
    color_swatch_017_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_017_03`,
    color_swatch_018_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_018_01`,
    color_swatch_018_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_018_02`,
    color_swatch_018_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_018_03`,
    color_swatch_019_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_019_01`,
    color_swatch_019_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_019_02`,
    color_swatch_019_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_019_03`,
    color_swatch_020_01: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_020_01`,
    color_swatch_020_02: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_020_02`,
    color_swatch_020_03: `${sitePrefix}.home_app.personalized_recommendations.color_swatch_020_03`,
    favorite_001: `${sitePrefix}.home_app.personalized_recommendations.favorite_001`,
    favorite_002: `${sitePrefix}.home_app.personalized_recommendations.favorite_002`,
    favorite_003: `${sitePrefix}.home_app.personalized_recommendations.favorite_003`,
    favorite_004: `${sitePrefix}.home_app.personalized_recommendations.favorite_004`,
    favorite_005: `${sitePrefix}.home_app.personalized_recommendations.favorite_005`,
    favorite_006: `${sitePrefix}.home_app.personalized_recommendations.favorite_006`,
    favorite_007: `${sitePrefix}.home_app.personalized_recommendations.favorite_007`,
    favorite_008: `${sitePrefix}.home_app.personalized_recommendations.favorite_008`,
    favorite_009: `${sitePrefix}.home_app.personalized_recommendations.favorite_009`,
    favorite_010: `${sitePrefix}.home_app.personalized_recommendations.favorite_010`,
    favorite_011: `${sitePrefix}.home_app.personalized_recommendations.favorite_011`,
    favorite_012: `${sitePrefix}.home_app.personalized_recommendations.favorite_012`,
    favorite_013: `${sitePrefix}.home_app.personalized_recommendations.favorite_013`,
    favorite_014: `${sitePrefix}.home_app.personalized_recommendations.favorite_014`,
    favorite_015: `${sitePrefix}.home_app.personalized_recommendations.favorite_015`,
    favorite_016: `${sitePrefix}.home_app.personalized_recommendations.favorite_016`,
    favorite_017: `${sitePrefix}.home_app.personalized_recommendations.favorite_017`,
    favorite_018: `${sitePrefix}.home_app.personalized_recommendations.favorite_018`,
    favorite_019: `${sitePrefix}.home_app.personalized_recommendations.favorite_019`,
    favorite_020: `${sitePrefix}.home_app.personalized_recommendations.favorite_020`,
    product_001: `${sitePrefix}.home_app.personalized_recommendations.product_001`,
    product_002: `${sitePrefix}.home_app.personalized_recommendations.product_002`,
    product_003: `${sitePrefix}.home_app.personalized_recommendations.product_003`,
    product_004: `${sitePrefix}.home_app.personalized_recommendations.product_004`,
    product_005: `${sitePrefix}.home_app.personalized_recommendations.product_005`,
    product_006: `${sitePrefix}.home_app.personalized_recommendations.product_006`,
    product_007: `${sitePrefix}.home_app.personalized_recommendations.product_007`,
    product_008: `${sitePrefix}.home_app.personalized_recommendations.product_008`,
    product_009: `${sitePrefix}.home_app.personalized_recommendations.product_009`,
    product_010: `${sitePrefix}.home_app.personalized_recommendations.product_010`,
    product_011: `${sitePrefix}.home_app.personalized_recommendations.product_011`,
    product_012: `${sitePrefix}.home_app.personalized_recommendations.product_012`,
    product_013: `${sitePrefix}.home_app.personalized_recommendations.product_013`,
    product_014: `${sitePrefix}.home_app.personalized_recommendations.product_014`,
    product_015: `${sitePrefix}.home_app.personalized_recommendations.product_015`,
    product_016: `${sitePrefix}.home_app.personalized_recommendations.product_016`,
    product_017: `${sitePrefix}.home_app.personalized_recommendations.product_017`,
    product_018: `${sitePrefix}.home_app.personalized_recommendations.product_018`,
    product_019: `${sitePrefix}.home_app.personalized_recommendations.product_019`,
    product_020: `${sitePrefix}.home_app.personalized_recommendations.product_020`,
    recommendation_group_01_product_001: `${sitePrefix}.home_app.personalized_recommendations.recommendation_group_01_product_001`,
    recommendation_group_01_product_002: `${sitePrefix}.home_app.personalized_recommendations.recommendation_group_01_product_002`,
    recommendation_group_01_product_003: `${sitePrefix}.home_app.personalized_recommendations.recommendation_group_01_product_003`,
    recommendation_group_02_product_001: `${sitePrefix}.home_app.personalized_recommendations.recommendation_group_02_product_001`,
    recommendation_group_02_product_002: `${sitePrefix}.home_app.personalized_recommendations.recommendation_group_02_product_002`,
    recommendation_group_02_product_003: `${sitePrefix}.home_app.personalized_recommendations.recommendation_group_02_product_003`,
    tab_option_01: `${sitePrefix}.home_app.personalized_recommendations.tab_option_01`,
    tab_option_02: `${sitePrefix}.home_app.personalized_recommendations.tab_option_02`,
    tab_option_03: `${sitePrefix}.home_app.personalized_recommendations.tab_option_03`,
    tab_option_04: `${sitePrefix}.home_app.personalized_recommendations.tab_option_04`,
    tab_option_05: `${sitePrefix}.home_app.personalized_recommendations.tab_option_05`,
    toggle_product_layout: `${sitePrefix}.home_app.personalized_recommendations.toggle_product_layout`,
  },
  product_floor_01: {
    code: `${sitePrefix}.home_app.product_floor_01`,
    color_swatch_001_01: `${sitePrefix}.home_app.product_floor_01.color_swatch_001_01`,
    color_swatch_001_02: `${sitePrefix}.home_app.product_floor_01.color_swatch_001_02`,
    color_swatch_001_03: `${sitePrefix}.home_app.product_floor_01.color_swatch_001_03`,
    color_swatch_002_01: `${sitePrefix}.home_app.product_floor_01.color_swatch_002_01`,
    color_swatch_002_02: `${sitePrefix}.home_app.product_floor_01.color_swatch_002_02`,
    color_swatch_002_03: `${sitePrefix}.home_app.product_floor_01.color_swatch_002_03`,
    color_swatch_003_01: `${sitePrefix}.home_app.product_floor_01.color_swatch_003_01`,
    color_swatch_003_02: `${sitePrefix}.home_app.product_floor_01.color_swatch_003_02`,
    color_swatch_003_03: `${sitePrefix}.home_app.product_floor_01.color_swatch_003_03`,
    color_swatch_004_01: `${sitePrefix}.home_app.product_floor_01.color_swatch_004_01`,
    color_swatch_004_02: `${sitePrefix}.home_app.product_floor_01.color_swatch_004_02`,
    color_swatch_004_03: `${sitePrefix}.home_app.product_floor_01.color_swatch_004_03`,
    color_swatch_005_01: `${sitePrefix}.home_app.product_floor_01.color_swatch_005_01`,
    color_swatch_005_02: `${sitePrefix}.home_app.product_floor_01.color_swatch_005_02`,
    color_swatch_005_03: `${sitePrefix}.home_app.product_floor_01.color_swatch_005_03`,
    color_swatch_006_01: `${sitePrefix}.home_app.product_floor_01.color_swatch_006_01`,
    color_swatch_006_02: `${sitePrefix}.home_app.product_floor_01.color_swatch_006_02`,
    color_swatch_006_03: `${sitePrefix}.home_app.product_floor_01.color_swatch_006_03`,
    color_swatch_007_01: `${sitePrefix}.home_app.product_floor_01.color_swatch_007_01`,
    color_swatch_007_02: `${sitePrefix}.home_app.product_floor_01.color_swatch_007_02`,
    color_swatch_007_03: `${sitePrefix}.home_app.product_floor_01.color_swatch_007_03`,
    color_swatch_008_01: `${sitePrefix}.home_app.product_floor_01.color_swatch_008_01`,
    color_swatch_008_02: `${sitePrefix}.home_app.product_floor_01.color_swatch_008_02`,
    color_swatch_008_03: `${sitePrefix}.home_app.product_floor_01.color_swatch_008_03`,
    favorite_001: `${sitePrefix}.home_app.product_floor_01.favorite_001`,
    favorite_002: `${sitePrefix}.home_app.product_floor_01.favorite_002`,
    favorite_003: `${sitePrefix}.home_app.product_floor_01.favorite_003`,
    favorite_004: `${sitePrefix}.home_app.product_floor_01.favorite_004`,
    favorite_005: `${sitePrefix}.home_app.product_floor_01.favorite_005`,
    favorite_006: `${sitePrefix}.home_app.product_floor_01.favorite_006`,
    favorite_007: `${sitePrefix}.home_app.product_floor_01.favorite_007`,
    favorite_008: `${sitePrefix}.home_app.product_floor_01.favorite_008`,
    product_001: `${sitePrefix}.home_app.product_floor_01.product_001`,
    product_002: `${sitePrefix}.home_app.product_floor_01.product_002`,
    product_003: `${sitePrefix}.home_app.product_floor_01.product_003`,
    product_004: `${sitePrefix}.home_app.product_floor_01.product_004`,
    product_005: `${sitePrefix}.home_app.product_floor_01.product_005`,
    product_006: `${sitePrefix}.home_app.product_floor_01.product_006`,
    product_007: `${sitePrefix}.home_app.product_floor_01.product_007`,
    product_008: `${sitePrefix}.home_app.product_floor_01.product_008`,
    view_more: `${sitePrefix}.home_app.product_floor_01.view_more`,
    view_more_tile: `${sitePrefix}.home_app.product_floor_01.view_more_tile`,
  },
  quick_categories: {
    code: `${sitePrefix}.home_app.quick_categories`,
    category_entry_01: `${sitePrefix}.home_app.quick_categories.category_entry_01`,
    category_entry_02: `${sitePrefix}.home_app.quick_categories.category_entry_02`,
    category_entry_03: `${sitePrefix}.home_app.quick_categories.category_entry_03`,
    category_entry_04: `${sitePrefix}.home_app.quick_categories.category_entry_04`,
    category_entry_05: `${sitePrefix}.home_app.quick_categories.category_entry_05`,
    category_entry_06: `${sitePrefix}.home_app.quick_categories.category_entry_06`,
    category_entry_07: `${sitePrefix}.home_app.quick_categories.category_entry_07`,
  },
  service_promises: {
    code: `${sitePrefix}.home_app.service_promises`,
    service_entry_01: `${sitePrefix}.home_app.service_promises.service_entry_01`,
    service_entry_02: `${sitePrefix}.home_app.service_promises.service_entry_02`,
    service_entry_03: `${sitePrefix}.home_app.service_promises.service_entry_03`,
  },
  shop_by_lenses: {
    code: `${sitePrefix}.home_app.shop_by_lenses`,
    lens_entry_01: `${sitePrefix}.home_app.shop_by_lenses.lens_entry_01`,
    lens_entry_02: `${sitePrefix}.home_app.shop_by_lenses.lens_entry_02`,
    lens_entry_03: `${sitePrefix}.home_app.shop_by_lenses.lens_entry_03`,
    lens_entry_04: `${sitePrefix}.home_app.shop_by_lenses.lens_entry_04`,
    lens_entry_05: `${sitePrefix}.home_app.shop_by_lenses.lens_entry_05`,
    lens_entry_06: `${sitePrefix}.home_app.shop_by_lenses.lens_entry_06`,
  },
  shop_by_shapes: {
    code: `${sitePrefix}.home_app.shop_by_shapes`,
    shape_entry_01: `${sitePrefix}.home_app.shop_by_shapes.shape_entry_01`,
    shape_entry_02: `${sitePrefix}.home_app.shop_by_shapes.shape_entry_02`,
    shape_entry_03: `${sitePrefix}.home_app.shop_by_shapes.shape_entry_03`,
    shape_entry_04: `${sitePrefix}.home_app.shop_by_shapes.shape_entry_04`,
    shape_entry_05: `${sitePrefix}.home_app.shop_by_shapes.shape_entry_05`,
    shape_entry_06: `${sitePrefix}.home_app.shop_by_shapes.shape_entry_06`,
    shape_entry_07: `${sitePrefix}.home_app.shop_by_shapes.shape_entry_07`,
  },
  shop_by_vibes: {
    code: `${sitePrefix}.home_app.shop_by_vibes`,
    style_entry_01: `${sitePrefix}.home_app.shop_by_vibes.style_entry_01`,
    style_entry_02: `${sitePrefix}.home_app.shop_by_vibes.style_entry_02`,
    style_entry_03: `${sitePrefix}.home_app.shop_by_vibes.style_entry_03`,
    style_entry_04: `${sitePrefix}.home_app.shop_by_vibes.style_entry_04`,
    style_entry_05: `${sitePrefix}.home_app.shop_by_vibes.style_entry_05`,
    style_entry_06: `${sitePrefix}.home_app.shop_by_vibes.style_entry_06`,
  },
  site_notice: {
    code: `${sitePrefix}.home_app.site_notice`,
    open_promotion: `${sitePrefix}.home_app.site_notice.open_promotion`,
  },
} as const satisfies SpmPageCodes;
